/**
 * @GENERATED from Figma node 3638:51941
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ExeBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="m22.74 1.875.114.685c.394 2.363.013 5.266-1.432 7.734-1.466 2.502-4.01 4.527-7.84 5.074l-.48.069-3.923-3.923.069-.48c.547-3.83 2.571-6.375 5.073-7.84 2.469-1.446 5.372-1.826 7.735-1.433zM21.027 3.59c-1.812-.15-3.92.224-5.724 1.28-1.912 1.12-3.507 3.018-4.056 5.967l2.533 2.532c2.949-.548 4.847-2.143 5.966-4.055 1.056-1.803 1.43-3.912 1.28-5.724"
      clipRule="evenodd"
    />
    <path
      fill="#7F776F"
      d="M18.235 6.38c-.616-.615-1.215-.615-1.83 0-.617.617-.617 1.216 0 1.832.615.616 1.214.616 1.83 0s.616-1.215 0-1.831M10.31 4.985l3.675-.108c-.992.718-3.102 2.681-3.607 4.784l-4.043 1.297L4.96 9.585l4.032-4.032c.35-.35.821-.553 1.316-.568M19.63 14.306l.109-3.675c-.638.91-2.488 2.908-4.784 3.607l-1.297 4.043 1.373 1.373 4.032-4.032c.35-.35.553-.82.568-1.316"
    />
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="m8.394 14.848 5.493-5.492 1.373 1.373-5.493 5.492z"
      clipRule="evenodd"
    />
    <path
      fill="#7F776F"
      d="m1 19.102 4.647-4.599 1.365 1.38-4.646 4.599zM5.399 21.002l3.377-3.332 1.364 1.382-3.377 3.332z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ExeBright);
export { ForwardRef as ExeBright };
